import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import NeighborsIcon from "../icons/neighbors-icon";
import {
  HeroContainer,
  HeroImage,
  HeroTextContent,
  Logo,
  LogoText,
  Title,
  Description
} from "./Hero.styled";
import { BREAKPOINTS } from "../../containers/impact-report/constants";

const ICON_SIZE = 30;

const Hero = ({ mobileImageUrl, desktopImageUrl }) => {
  const { t } = useTranslation();

  return (
    <HeroContainer>
      <picture>
        <source
          media={`(min-width: ${BREAKPOINTS.MD})`}
          srcSet={desktopImageUrl}
        />
        <HeroImage src={mobileImageUrl} alt={t("impactReport.hero.imageAlt")} />
      </picture>
      <HeroTextContent>
        <Logo>
          <NeighborsIcon width={ICON_SIZE} height={ICON_SIZE} />
          <LogoText>{t("impactReport.hero.logoText")}</LogoText>
        </Logo>
        <Title>{t("impactReport.hero.title")}</Title>
        <Description>{t("impactReport.hero.description")}</Description>
      </HeroTextContent>
    </HeroContainer>
  );
};

Hero.propTypes = {
  mobileImageUrl: PropTypes.string.isRequired,
  desktopImageUrl: PropTypes.string.isRequired
};

export default Hero;
